/**
 * @file コンポーネント：スレッド確認モーダル DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Modal } from "~/src/components/projects/Modal";
import { Paragraph } from "~/src/components/uiparts/Paragraph";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <Modal
            buttonlist={[
                {
                    // キャンセル
                    buttonType: "cancel",
                    onClick: (e) => {
                        e.preventDefault();
                        if (props.fnOnClickCancel) {
                            props.fnOnClickCancel();
                        }
                        props.setIsOpenModalThreadConfirm(false);
                    },
                    text: localized["Label.Cancel"],
                },
                {
                    // OK
                    buttonType: "caution",
                    onClick: (e) => {
                        e.preventDefault();
                        props.fnOnClickAgree();
                    },
                    text: localized["Label.Ok"],
                },
            ]}
            content={[
                <Paragraph
                    key="content"
                    onColor="white"
                    text={props.paragraph}
                />,
            ]}
            hasButtonClose={true}
            isShow={props.isOpenModalThreadConfirm}
            setIsShow={props.setIsOpenModalThreadConfirm}
        />
    );
};
